
import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import Hero from "@/components/Hero";

interface CheckoutContainerProps {
  title: string;
  subtitle?: string;
  courseError: string | null;
  courseLoading: boolean;
  courseData: any | null;
  children: React.ReactNode;
}

const CheckoutContainer = ({
  title,
  subtitle = "Vaid veel üks samm enne, kui saad alustada oma õpiteekonda",
  courseError,
  courseLoading,
  courseData,
  children,
}: CheckoutContainerProps) => {
  return (
    <div className="fade-in">
      <Hero 
        title={title}
        subtitle={subtitle}
        bgColor="bg-gradient-to-r from-kaija-light to-kaija-sage"
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom max-w-6xl">
          {courseError && (
            <Alert variant="destructive" className="mb-8">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>{courseError}</AlertDescription>
            </Alert>
          )}
          
          {courseLoading ? (
            <div className="flex items-center justify-center h-60">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-kaija-accent"></div>
            </div>
          ) : courseData ? (
            children
          ) : (
            <div className="text-center py-12">
              <h2 className="text-xl font-medium mb-4">Kursust ei leitud</h2>
              <a href="/courses" className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
                Vaata kursuseid
              </a>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default CheckoutContainer;
